import React from "react";

const HowToBecomeAPosp = () => {
    return (
        <div className="mt-5 pt-5 pb-5" style={{ backgroundColor: "#F7F7F7" }}>
            <div className="d-flex align-item-center justify-content-center pb-5">
                <h2 style={{ color: "#1f2c6a" }}>How to become PoSP with Buy Policy</h2>
            </div>
            <div className="container">
                <div className="row d-flex align-item-center justify-content-center ">
                    <div className="howBecome-div-circel-div col-md-3 col-sm-12">
                        <div className="howBecome-div-circel" style={{backgroundColor:"#DC5F00"}}>
                            <h4 className="m-0" >Step 1</h4>
                        </div>
                        <h6 className="howBecome-div-circel-h6">
                            Sign up by filling our PoSP form given above, and our team will
                            get back to you with more details.
                        </h6>
                    </div>
                    <div className="howBecome-div-circel-div col-md-3 col-sm-12">
                        <div className="howBecome-div-circel" style={{backgroundColor:"#FF7F3E"}}>
                            <h4 className="m-0">Step 2</h4>
                        </div>
                        <h6 className="howBecome-div-circel-h6">Complete your 15-hour training with us.</h6>
                    </div>
                    <div className="howBecome-div-circel-div col-md-3 col-sm-12">
                        <div className="howBecome-div-circel" style={{backgroundColor:"#2A629A"}}>
                            <h4 className="m-0">Step 3</h4>
                        </div>
                        <h6 className="howBecome-div-circel-h6">Complete the prescribed examination.</h6>
                    </div>
                    <div className="howBecome-div-circel-div col-md-3 col-sm-12">
                        <div className="howBecome-div-circel" style={{backgroundColor:"#003285"}}>
                            <h4 className="m-0">Step 4</h4>
                        </div>
                        <h6 className="howBecome-div-circel-h6">
                            Sign the agreement with us and that’s it! You’ll be a certified
                            PoSP.
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowToBecomeAPosp;
